import Swiper, { Keyboard, Navigation, Thumbs } from 'swiper';

import '../../sass/blocks/carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $carousels = document.querySelectorAll('.carousel');

    if (!$carousels) return;

    $carousels.forEach($carousel => {
        const $carouselEl = $carousel.querySelector('.carousel__carousel');
        const $carouselPrev = $carousel.querySelector('.carousel__navigation-prev');
        const $carouselNext = $carousel.querySelector('.carousel__navigation-next');
        const $carouselNumbers = $carousel.querySelector('.carousel__numbers');

        const initCarousel = () => {
            if (!$carouselEl) return;

            const carouselNumbers = new Swiper($carouselNumbers, {
                loop: true,
                direction: 'vertical',
                allowTouchMove: false,
                speed: noMotionPreference.matches ? 300 : 0
            });

            new Swiper($carouselEl, {
                modules: [ Keyboard, Navigation, Thumbs ],
                loop: true,
                keyboard: {
                    enabled: true
                },
                navigation: {
                    prevEl: $carouselPrev,
                    nextEl: $carouselNext
                },
                thumbs:  {
                    swiper: carouselNumbers
                },
                speed: noMotionPreference.matches ? 300 : 0
            });
        }

        initCarousel();
    });
})();
